import Courses from '../section/coursepage/Courses';
import CourseHeader from '../components/CourseHeader';

export default function CoursePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-amber-50/30 to-white">
      <CourseHeader />
      <div className="pt-16">
        <Courses />
        
      </div>
    </div>
  );
}